/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Text_PlaceholderInputs */

const en_tts_tool_text_placeholder = /** @type {(inputs: Tts_Tool_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste any text here...`)
};

const es_tts_tool_text_placeholder = /** @type {(inputs: Tts_Tool_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega cualquier texto aquí...`)
};

/**
* | output |
* | --- |
* | "Paste any text here..." |
*
* @param {Tts_Tool_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_text_placeholder = /** @type {((inputs?: Tts_Tool_Text_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Text_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_text_placeholder(inputs)
	return en_tts_tool_text_placeholder(inputs)
});